import React, { useEffect } from "react";
import { WDHImage, triggerEvent } from '@demant/wdh';

var PlainImageSpot = function PlainImageSpot(_ref) {
  var settings = _ref.settings;
  var spotList = settings.elements || [];
  useEffect(function () {
    triggerEvent('link-embed-code-detected');
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: "image-spot-elements plain-image-spot"
  }, spotList.map(function (item, index) {
    return /*#__PURE__*/React.createElement("li", {
      className: "image-spot-element",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "scLooseFrameZone",
      sc_item: item.sitecoreItem || ''
    }, /*#__PURE__*/React.createElement("span", {
      className: "scChromeData"
    }, item.sitecoreChromeData || ''), item.link && item.image && /*#__PURE__*/React.createElement("a", {
      href: item.link.href
    }, /*#__PURE__*/React.createElement("div", {
      className: "image-spot-element-image"
    }, /*#__PURE__*/React.createElement(WDHImage, {
      image: item.image.image
    }))), !item.link && item.image && /*#__PURE__*/React.createElement("div", {
      className: "image-spot-element-image"
    }, /*#__PURE__*/React.createElement(WDHImage, {
      image: item.image.image
    })), item.header && /*#__PURE__*/React.createElement("div", {
      className: "image-spot-element-header",
      dangerouslySetInnerHTML: {
        __html: item.header
      }
    }), item.text && /*#__PURE__*/React.createElement("div", {
      className: "image-spot-element-text",
      dangerouslySetInnerHTML: {
        __html: item.text
      }
    }), item.link && /*#__PURE__*/React.createElement("div", {
      className: "image-spot-element-link"
    }, /*#__PURE__*/React.createElement("a", {
      href: item.link.href,
      title: item.link.title
    }, item.link.content, ' '))));
  })));
};

export default PlainImageSpot;